<template>
  <div>
    <div class="title title-mb">
      <div class="title-block">
        <div class="block"></div>
        <div class="titleText">容器明细</div>
      </div>
    </div>
    <TablePublic
      :colLists="colLists"
      :tableData="tableData"
      :showIndex="false"
      :paginationFlag="false"
      :summary="true"
      :summaryMethod="getSummaries"
    >
    </TablePublic>
  </div>
</template>

<script>
import { getWarehouseStorageDetail } from '@/api/manage/warehouse'
import TablePublic from '@/components/tablePublic'
export default {
  components: {
    TablePublic,
  },
  data() {
    return {
      colLists: [
        {
          prop: 'storageContainerCode',
          label: '容器编号',
          isTrue: true,
        },
        {
          prop: 'totalWeight',
          label: '重量（斤）',
          isTrue: true,
        },
        {
          prop: 'grossWeight',
          label: '毛重（斤）',
          isTrue: true,
        },
        {
          prop: 'quantity',
          label: '净重（斤）',
          isTrue: true,
        },
        {
          prop: 'customerName',
          label: '所属客户',
          isTrue: true,
        },
      ],
      tableData: [],
    }
  },
  methods: {
    getDetails(row) {
      if (row) {
        getWarehouseStorageDetail({
          inboundBizNo: row.inboundBizNo,
          pickingBatchBizNo: row.pickingBatchBizNo,
          storageAreaCode: row.storageAreaCode,
          storageLocCode: row.storageLocCode,
          storageTrayCode: row.storageTrayCode,
          warehouseCode: row.warehouseCode,
        }).then((res) => {
          if (res.flag) {
            this.tableData = res.data && res.data.map(d=>{
              d.customerName = row.customerName
              return d
            })
          }
        })
      }
    },
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (index === 1) {
          sums[index] = this.sumArr(data, 'totalWeight') || '-'
        }
        if (index === 2) {
          sums[index] = this.sumArr(data, 'grossWeight') || '-'
        }
        if (index === 3) {
          sums[index] = this.sumArr(data, 'quantity') || '-'
        }
      })
      return sums //返回sums数组,sums数组中各项就会显示在合计行的各列中
    },
  },
}
</script>

<style scoped lang='less'>
@import '../../../../assets/form.less';
::v-deep {
  .no-contract-type {
    padding: 30px;
    background-color: #f8f8f8;
    border-radius: 12px;
    text-align: center;
    border: 1px solid #dde4ff;
    margin-top: 10px;
  }
}
</style>